import React, { FC, memo } from 'react'
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material'

export const Button: FC<MuiButtonProps> = memo((props) => {
    return <MuiButton data-automation-id={props.id} {...props} />
})
